import service from '@/utils/service'
import { stat } from 'fs'
import { FILTER_PROJECT_CODES } from '@/constants/common';


const state = {
    is_login: false,
    id: null,
    name: null,
    username: null,
    admin:false,
    staff: false,
    projects: null,
    email: null,
    auth: null,
}

const mutations = {
    set_user (state, user) {
      state.is_login = true
      state.id = user.id
      state.name = user.name
      state.username = user.username
      state.admin = user.admin
      state.staff = user.staff
      state.email = user.email
      window.userInfo = {email: user.email, username: user.username};
      if (window.WaterMark) {
        window.WaterMark.mark({ text: user.username })
      }
      
    },
    clear_user(state) {
      state.is_login = false
      state.id = null
      state.name = null
      state.admin = false
      state.staff = false
      state.email = null
    },
    set_projects(state, projects) {
      state.projects = projects      
    },
    clear_projects(state) {
      state.projects = null
    },
    set_auth(state, auth) {
      state.auth = auth     
    },
    clear_auth(state) {
      state.auth = 'normal'
    }
  }

  const actions = {
    async get_user(context) {
      context.commit("clear_user");
      let user = await service.userInfo()
      context.commit("set_user", user)
    },
    get_projects(context, detail) {
      context.commit("clear_projects");
      return service.getData(service.api.common.project, {detail}).then((data)=>{
        let auth = 'normal', admin = false;
        // FIXME: 临时方案
        // data = _.filter(data, (d) => (!FILTER_PROJECT_CODES.includes(d.code)));

        // 如果有一个有首页数据权限则 auth='data'
        if(_.filter(data, {home:true}).length > 0) {
          auth = 'data'
        }
        context.commit('set_auth', auth)

        let proj_code = service.PROJ_CODE
        // 如果有管理权限则
        if(proj_code?_.filter(data, {code:proj_code, admin:true}).length > 0:_.filter(data, {admin:true}).length > 0) {
            admin = true
        }
        if(proj_code) {
          context.commit('set_admin', admin)
        }
        context.commit("set_projects", data)
        return data
      })
    }
  }

  const getters = {
   
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }